export enum MarketingDataStatus {
  PRE_FILLED = 'PRE-FILLED',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  CLOSED = 'CLOSED',
  SKIPPED = 'SKIPPED',
}

export interface MarketingDataResponse {
  industry: string | null
  useCase: string | null
  source: string | null
  description: string | null
  status: MarketingDataStatus
}

export interface MarketingDataSubmitPayload {
  industry: string
  useCase: string
  source: string
  description: string | null
}

export interface MarketingDataFormScheme {
  industry: string
  useCase: string
  source: string
  description: string
}

export const MARKETING_DATA_OTHER_SOURCE = 'Other'

export const MARKETING_DATA_DESCRIPTION_MAX_LENGTH = 1000

export const MARKETING_DATA_INDUSTRY_OPTIONS: string[] = [
  'Real Estate',
  'Healthcare',
  'Energy',
  'Entertainment',
  'Retail',
  'Agriculture',
  'Insurance',
  'Education',
  'Hospitality',
  'Financial',
  'Gambling',
  'Construction',
  'NGO',
  'Manufacturing',
  'Government',
  'Technology',
  'Communication',
  'Legal',
  'Professional',
  'Human Resources',
  'Political',
  'Postal',
  'Transportation',
]

export const MARKETING_DATA_USE_CASE_OPTIONS: string[] = [
  '2FA',
  'App Notifications',
  'Appointments',
  'Auctions',
  'Auto Repair Services',
  'Bank Transfers',
  'Billing',
  'Booking Confirmations',
  'Business Updates',
  'Career Training',
  'Chatbot',
  'Conversational / Alerts',
  'Courier Services & Deliveries',
  'COVID-19 Alerts',
  'Emergency Alerts',
  'Events & Planning',
  'Financial Services',
  'Fraud Alerts',
  'Fundraising',
  'General Marketing',
  'General School Updates',
  'Healthcare Alerts',
  'Housing Community Updates',
  'HR / Staffing',
  'Insurance Services',
  'Job Dispatch',
  'Legal Services',
  'Mixed',
  'Motivational Reminders',
  'Notary Notifications',
  'Order Notifications',
  'Political',
  'Public Works',
  'Real Estate Services',
  'Religious Services',
  'Repair and Diagnostics Alerts',
  'Rewards Program',
  'Surveys',
  'System Alerts',
  'Voting Reminders',
  'Waitlist Alerts',
  'Webinar Reminders',
  'Workshop Alerts',
]

export const MARKETING_DATA_SOURCE_OPTIONS: { value: string; label?: string }[] = [
  { value: 'Affiliate / Partner' },
  { value: 'AI (ChatGPT, Claude, Gemini, etc)', label: 'AI (ChatGPT, Claude, Gemini, etc.)' },
  { value: 'App Store / Marketplace' },
  { value: 'Blog / Article' },
  { value: 'Comparison Website' },
  { value: 'Email Newsletter' },
  { value: 'Online Review Site (G2, Capterra, etc.)' },
  { value: 'Recommendation from a Friend / Colleague' },
  { value: 'Reddit or Forum' },
  { value: 'Search - Bing', label: 'Search \u2014 Bing' },
  { value: 'Search - Google', label: 'Search \u2014 Google' },
  { value: 'Search - Google Ads', label: 'Search \u2014 Google Ads' },
  { value: 'Social Media - Facebook', label: 'Social Media \u2014 Facebook' },
  { value: 'Social Media - Instagram', label: 'Social Media \u2014 Instagram' },
  { value: 'Social Media - LinkedIn', label: 'Social Media \u2014 LinkedIn' },
  { value: 'Social Media - X (Twitter)', label: 'Social Media \u2014 X (Twitter)' },
  { value: 'YouTube' },
  { value: MARKETING_DATA_OTHER_SOURCE },
]
